'use strict'

export const createNode = (element) => {}
